

exports.__esModule = true;
exports.$CONTEXT = exports.$integration = exports.$FLOWS = undefined;

var _$DEFAULT, _$CONTEXT$FULLPAGE, _$CONTEXT$LIGHTBOX, _$integration$init;

var _squid = require('squid');

Object.defineProperty(exports, '$integration', {
    enumerable: true,
    get: function get() {
        return _squid.$integration;
    }
});
Object.defineProperty(exports, '$CONTEXT', {
    enumerable: true,
    get: function get() {
        return _squid.$CONTEXT;
    }
});
var $FLOWS = exports.$FLOWS = {

    // Regular end-to-end checkout flow with one entry and one exit point
    CHECKOUT: 'CHECKOUT',

    // Flow for collecting user data, then messaging back to parent once done
    COLLECT_DATA: 'COLLECT_DATA',

    // Partner flow [ TODO: FACTOR THIS OUT ]
    PARTNER: 'PARTNER',

    // Incontext lightbox flow
    INCONTEXT_LIGHTBOX: 'INCONTEXT_LIGHTBOX',

    // Incontext popup flow
    INCONTEXT_POPUP: 'INCONTEXT_POPUP',

    // Native checkout flow
    NATIVE_CHECKOUT: 'NATIVE_CHECKOUT',

    // Messenger Integration flow
    MESSENGER_BA_INTEGRATION: 'MESSENGER_BA_INTEGRATION'
};

_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {

    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,
    ALLOW_ONETOUCH_TOKEN_EXCHANGE: false,

    FALLBACK: true,
    REDIRECT_TOP: true,
    REDIRECT_QUERY_PARAM: false,
    POST_MESSAGE_PARENT: false

}, _$DEFAULT[$FLOWS.PARTNER] = {

    FALLBACK: false,
    REDIRECT_TOP: false,
    POST_MESSAGE_PARENT: false
}, _$DEFAULT[$FLOWS.INCONTEXT_LIGHTBOX] = {

    ALLOW_ONETOUCH_TOKEN_EXCHANGE: true,
    POST_MESSAGE_PARENT: true
}, _$DEFAULT[$FLOWS.INCONTEXT_POPUP] = {

    POST_MESSAGE_PARENT: true
}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {

    CAN_FRAMEBUST: false,
    CAN_FALLBACK_TO_POPUP: false,
    CAN_CLOSE_SELF: false

}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {

    REDIRECT_QUERY_PARAM: true

}, _$CONTEXT$FULLPAGE), _$integration$init[_squid.$CONTEXT.LIGHTBOX] = (_$CONTEXT$LIGHTBOX = {

    ALLOW_AUTH: false,
    ALLOW_COLLECT_DATA: false,

    CAN_FRAMEBUST: true,
    CAN_FALLBACK_TO_POPUP: true,
    CAN_CLOSE_SELF: false,

    RETURN_FROM_DATA_COLLECTION_POPUP: false

}, _$CONTEXT$LIGHTBOX[$FLOWS.MESSENGER_BA_INTEGRATION] = {

    IS_MESSENGER_BA_INTEGRATION: true

}, _$CONTEXT$LIGHTBOX[$FLOWS.PARTNER] = {

    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,
    CAN_FALLBACK_TO_POPUP: false,
    POST_MESSAGE_PARENT: false
}, _$CONTEXT$LIGHTBOX), _$integration$init[_squid.$CONTEXT.POPUP] = {
    ALLOW_AUTH: true,
    ALLOW_COLLECT_DATA: true,

    CAN_FRAMEBUST: true,
    CAN_FALLBACK_TO_POPUP: true,
    CAN_CLOSE_SELF: false
}, _$integration$init));

_squid.$integration;

_squid.$DEFAULT;

_squid.$CONTEXT;


//////////////////
// WEBPACK FOOTER
// ./js/lib/integration.js
// module id = ./js/lib/integration.js
// module chunks = 1